import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetEmployerStats = {
  getEmployerStats: { data: null, loading: false, error: null },
};

export const getEmployerStats = createAsyncThunk('user/getEmployerStats', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/employers/categories`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetEmployerStats = {
  [getEmployerStats.pending]: (state) => {
    state.getEmployerStats.loading = true;
    state.getEmployerStats.error = null;
  },
  [getEmployerStats.fulfilled]: (state, action) => {
    state.getEmployerStats.loading = false;
    state.getEmployerStats.data = action.payload;
    state.getEmployerStats.error = null;
  },
  [getEmployerStats.rejected]: (state, action) => {
    state.getEmployerStats.loading = false;
    state.getEmployerStats.error = action.payload;
  },
};
